export const Routes = {
  HOME: '/',
  FORM: '/form',
  TABLE: '/table',
  LIST: '/list',
  DATA: '/data',
  LOGIN: '/login',
  ENVELOPES: '/envelopes',
  UPDATE_ENVELOPE: '/envelopes/:envelopeId',
  TEMPLATES: '/templates',
  PREPARE_TEMPLATE: '/prepare-template/:templateId',
  TEMPLATE_EDIT_EMBEDDED_VIEW: '/prepare-template/:templateId/add-fields',
  EMBEDDED_VIEW_REDIRECT_PAGE: '/embedded-view/redirect',
  DESKTOP_PROCESS: '/desktop-process',
  POST_SIGNING: '/post-signing',
  POST_SENDING: '/post-sending',
}
